import { gql } from "@apollo/client";

export const GET_DISTRICTS = gql`
  query GetDistrictsMap(
    $region: ID

  ) {
    districts: getDistricts(
      region: $region
      page: 1
      pageSize: 0
    ) {
      _id
      code
      name
      region {
        _id
        code
        name
      }
      geoBoundary {
        type
        coordinates
      }
    }
  }
`;